var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "end" } },
        [
          _c(
            "el-button",
            {
              staticClass: "create-button",
              attrs: { type: "primary" },
              on: { click: _vm.openCreateDialog },
            },
            [_vm._v(_vm._s(_vm.$t("Cuona.Group.new")))]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("GroupsTable", {
            staticClass: "group",
            attrs: { groups: _vm.groups, edit: false, loading: _vm.isLoading },
            on: { openCreateDialog: _vm.openCreateDialog },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("Cuona.Group.new"),
            width: "65%",
            top: "8vh",
            visible: _vm.isShowingDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowingDialog = $event
            },
            closed: _vm.closedDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isLoadingGroupSetting,
                  expression: "isLoadingGroupSetting",
                },
              ],
              ref: "dialogForm",
              staticClass: "form",
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                "label-width": "120px",
                model: _vm.dialogForm,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Cuona.Group.name"), prop: "name" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.dialogForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogForm, "name", $$v)
                      },
                      expression: "dialogForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Cuona.Group.manager"),
                    prop: "manager",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("Cuona.Group.choice") },
                      model: {
                        value: _vm.dialogForm.manager,
                        callback: function ($$v) {
                          _vm.$set(_vm.dialogForm, "manager", $$v)
                        },
                        expression: "dialogForm.manager",
                      },
                    },
                    _vm._l(_vm.ownerAndManagers, function (manager, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: manager.name, value: manager.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Cuona.Group.note") } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 3 },
                    model: {
                      value: _vm.dialogForm.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogForm, "description", $$v)
                      },
                      expression: "dialogForm.description",
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "CUONA" } }, [
                _c(
                  "div",
                  { staticClass: "content" },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "groupDeviceTable",
                        attrs: {
                          data: _vm.devices,
                          "cell-class-name": "el-table-cell",
                          "row-class-name": "el-table-row",
                          "max-height": "300",
                          "empty-text": "aaaa",
                        },
                        on: {
                          "row-click": _vm.toggleGroupedDevice,
                          "selection-change": _vm.setSelectedDevices,
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { type: "selection", width: "55" },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            label: _vm.$t("Cuona.Device.name"),
                            sortable: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c("img", {
                                    staticClass: "device-image",
                                    attrs: {
                                      src: _vm.getCuonaImage(props.row),
                                    },
                                  }),
                                  _c("span", [_vm._v(_vm._s(props.row.name))]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            width: "180px",
                            prop: "nfc_uid",
                            label: _vm.$t("Cuona.Device.id"),
                            sortable: "",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "groups",
                            label: _vm.$t("Cuona.Event.group"),
                            sortable: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _vm._l(props.row.groups, function (group) {
                                    return [
                                      _c(
                                        "el-tag",
                                        {
                                          staticClass: "tag",
                                          attrs: { size: "mini" },
                                        },
                                        [_vm._v(_vm._s(group.name))]
                                      ),
                                    ]
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.isLoadingGroupSetting },
                  on: {
                    click: function ($event) {
                      _vm.isShowingDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Cuona.Group.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.isLoadingGroupSetting,
                  },
                  on: { click: _vm.createGroup },
                },
                [_vm._v(_vm._s(_vm.$t("Cuona.Group.create")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }